/* eslint-disable @typescript-eslint/no-unsafe-assignment */
export const buildResponse = (eventParams) => {
  return {
    event: eventParams,
  };
};
/* eslint-enable */
